import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setHeaderTitle } from "stores/slices/layout";

import BroadcastListTable from "components/broadcastList/broadcastListTable";

const BroadcastListPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle("broadcastLists"));
  }, []);

  return (
    <div>
      <BroadcastListTable isOperator={true} />
    </div>
  );
};
export default BroadcastListPage;
